import * as sdk from '@cirqll/sdk';
import { isSameDay, isBefore, startOfToday, differenceInMinutes } from 'date-fns';
import { i18n } from '~/modules/i18n';

function isFullDayAppointment(appointment: Pick<sdk.Appointment, 'start_date' | 'end_date'>): boolean {
    return differenceInMinutes(appointment.end_date, appointment.start_date) >= 23 * 60 + 58;
}

export function formatAppointmentTime(appointment: Pick<sdk.Appointment, 'start_date' | 'end_date'>): string {
    if (isFullDayAppointment(appointment)) {
        return i18n.global.t('appointments.all_day');
    }
    return `${i18n.global.d(appointment.start_date, 'time')} - ${i18n.global.d(appointment.end_date, 'time')}`;
}

export function getDateColor(date?: Date): 'secondary' | 'warning' | 'success' {
    if (!date) return 'warning';
    if (isSameDay(date, new Date())) return 'secondary';
    if (isBefore(date, startOfToday())) return 'warning';
    return 'success';
}

export function getContractColor(contract: sdk.Contract): 'warning' | 'success' | 'red' {
    switch (contract.priority) {
        case 1:
            return 'red';
        case 2:
            return 'warning';
        case 3:
            return 'success';
    }
}

export function getCustomerColor(customer: Pick<sdk.Customer, 'priority'>): 'success' | 'gold' | 'warning' {
    switch (customer.priority) {
        case 1:
            return 'gold';
        case 2:
            return 'warning';
        case 3:
            return 'success';
    }
}
